import Backbone from "backbone";


let NotificationModel = Backbone.Model.extend("NotificationModel", {
    defaults: {
        user: false,
        escapeHtml: true,
        title: "",
        description: "",
        img: false,
        color: "default",
        timeout: 60 * 1000
    }
});

export default NotificationModel;
